/* TRIO – Pages légales : sommaire actif, ancres, copie du formulaire */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot(s) {
    if (s.__tlg) return;
    s.__tlg = true;

    /* hauteur du header collant */
    function setTop() {
      var hg = document.getElementById('header-group'), ann = document.querySelector('.tw-ann');
      if (!hg) return;
      var h = hg.offsetHeight - (ann ? ann.offsetHeight : 0);
      if (h > 20 && h < 200) s.style.setProperty('--tlg-top', h + 'px');
    }
    setTop(); window.addEventListener('resize', setTop);

    var toc = s.querySelector('[data-tlg-toc]');
    var secs = Array.prototype.slice.call(s.querySelectorAll('[data-tlg-sec]'));
    var links = toc ? Array.prototype.slice.call(toc.querySelectorAll('[data-tlg-link]')) : [];
    var current = '';

    function setOn(id) {
      if (id === current) return;
      current = id;
      links.forEach(function (a) {
        var on = a.getAttribute('data-tlg-link') === id;
        a.classList.toggle('is-on', on);
        if (on) {
          a.setAttribute('aria-current', 'true');
          /* barre horizontale (mobile) : on garde la pastille active visible, sans faire défiler la page */
          var bar = a.closest('.tlg-toc__in');
          if (bar && bar.scrollWidth > bar.clientWidth + 2) {
            var l = a.offsetLeft - (bar.clientWidth - a.offsetWidth) / 2;
            bar.scrollTo({ left: Math.max(0, l), behavior: reduce ? 'auto' : 'smooth' });
          }
        } else a.removeAttribute('aria-current');
      });
    }

    var ticking = false;
    function spy() {
      ticking = false;
      if (!secs.length) return;
      var line = window.innerHeight * 0.32, id = secs[0].id;
      for (var i = 0; i < secs.length; i++) {
        if (secs[i].getBoundingClientRect().top <= line) id = secs[i].id; else break;
      }
      /* en bas de document : dernier article */
      var last = secs[secs.length - 1].getBoundingClientRect();
      if (last.bottom <= window.innerHeight - 40) id = secs[secs.length - 1].id;
      setOn(id);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }
    if (links.length) {
      document.addEventListener('scroll', onScroll, { capture: true, passive: true });
      window.addEventListener('resize', onScroll);
      spy();
    }

    /* ancres : sur ordinateur la page défile dans un conteneur, on gère le défilement nous-mêmes */
    function toHash(hash, smooth) {
      if (!hash || hash.length < 2) return false;
      var t; try { t = s.querySelector(hash); } catch (e) { return false; }
      if (!t) return false;
      t.scrollIntoView({ behavior: smooth && !reduce ? 'smooth' : 'auto', block: 'start' });
      return true;
    }
    if (location.hash) setTimeout(function () { toHash(location.hash, false); }, 250);
    s.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var h = a.getAttribute('href');
      if (h === '#preferences-cookies') {
        e.preventDefault();
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
        return;
      }
      if (toHash(h, true)) {
        e.preventDefault();
        if (history.replaceState) history.replaceState(null, '', h);
        if (a.hasAttribute('data-tlg-link')) setOn(h.slice(1));
      }
    });

    /* copie du modèle de rétractation */
    var copy = s.querySelector('[data-tlg-copy]'), form = s.querySelector('[data-tlg-form]');
    if (copy && form) {
      var label = copy.querySelector('[data-tlg-copylabel]'), base = label.textContent, t = 0;
      copy.addEventListener('click', function () {
        var text = Array.prototype.map.call(form.querySelectorAll('p'), function (p) { return p.innerText.trim(); }).join('\n\n');
        function done(ok) {
          label.textContent = ok ? 'Modèle copié' : 'Sélectionnez le texte pour le copier';
          copy.classList.toggle('is-done', ok);
          clearTimeout(t); t = setTimeout(function () { label.textContent = base; copy.classList.remove('is-done'); }, 2400);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(false); });
        else done(false);
      });
    }
  }

  function init() { document.querySelectorAll('[data-tlg]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
